import { OvereenkomstHouder } from "@/models/ovk";
import { Reducer, createAction, createReducer } from "@reduxjs/toolkit";

export interface OvksState {
    data: OvereenkomstHouder[],
    loaded: boolean,
    filter_text: string | null;
}

const initialState: OvksState = {
    data: [],
    loaded: false,
    filter_text: null
}

const clearFilter = createAction('ovks/clear-filter');
const setFilterText = createAction<string>('ovks/set-filter-text');
const setDataAction = createAction<OvereenkomstHouder[]>('ovks/set-data');
const clearDataAction = createAction('ovks/clear-data');

export const ovksReducer = createReducer(
    initialState,
    (builder) => {
        builder.addCase(setDataAction, (state, action) => {
            state.data = action.payload;
            state.loaded = true;
        }).addCase(clearDataAction, (state, action) => {
            state.data = [];
            state.loaded = false;
        }).addCase(setFilterText, (state, action) => {
            state.filter_text = action.payload;
        }).addCase(clearFilter, (state, action) => {
            state.filter_text = null;
        })
    }
)

export const ovksActions = {
    set_data: setDataAction,
    clear_data: clearDataAction,
    set_filter_text: setFilterText,
    clear_filter: clearFilter
}